import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const SUPPORTED_LOCALES = [
  'en', 'en-GB', 'fr', 'de', 'es', 'pt', 'ru', 'ar', 'he', 'zh', 'ja', 'ko', 'pl', 'tr',
] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const RTL_LOCALES: ReadonlySet<SupportedLocale> = new Set(['ar', 'he'])

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: 'English',
  'en-GB': 'English (UK)',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  pt: 'Português',
  ru: 'Русский',
  ar: 'العربية',
  he: 'עברית',
  zh: '中文',
  ja: '日本語',
  ko: '한국어',
  pl: 'Polski',
  tr: 'Türkçe',
}

export const currentLocaleAtom = atomWithStorage<SupportedLocale>(
  'taloflow-locale',
  'en'
)

export const isRtlAtom = atom((get) => {
  const locale = get(currentLocaleAtom)
  return RTL_LOCALES.has(locale)
})

export const textDirectionAtom = atom((get) => {
  return get(isRtlAtom) ? 'rtl' : 'ltr'
})

export function isValidLocale(locale: string): locale is SupportedLocale {
  return SUPPORTED_LOCALES.includes(locale as SupportedLocale)
}
